export const TRIAGE_ORDER = ['urgent', 'immediate', 'standard', 'inconclusive', 'none'] as const;